import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const CalendarIcon = ({ className }) => (
    <svg className={className} id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19">
        <path
            id="b"
            d="M1,19c-.55,0-1-.45-1-1V1C0,.45,.45,0,1,0H20c.55,0,1,.45,1,1V18c0,.55-.45,1-1,1H1Zm1-2H19V4.73c-.3,.18-.65,.27-1,.27H2v12Z"
            fill="currentColor"
        />
    </svg>
);

CalendarIcon.propTypes = propTypes;
CalendarIcon.defaultProps = defaultProps;

export default CalendarIcon;
